import { render, staticRenderFns } from "./shareInfo.vue?vue&type=template&id=0843cb4e&scoped=true"
import script from "./shareInfo.vue?vue&type=script&lang=js"
export * from "./shareInfo.vue?vue&type=script&lang=js"
import style0 from "./shareInfo.vue?vue&type=style&index=0&id=0843cb4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0843cb4e",
  null
  
)

export default component.exports